{
  "confirmationNumber": "Nombor Pengesahan {number}",
  "dateTimeRange": "{date} dari {startTime} hingga {endTime}"
}
